import React from "react";

const HubIllustration = ({ src, alt = "", className = "hub-illustration" }) => {
  if (!src) return null;
  return <img src={src} alt={alt} className={className} decoding="async" draggable={false} />;
};

export default HubIllustration;
